module.exports = "/images/about.png";